export default "__VITE_ASSET__a2dc52b4__"